/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { SeqTemplateApi } from '../api/seqTemplate.api';
import { switchMap, map } from 'rxjs/operators';
import { SeqTemplateData, SeqTemplate } from '../../../interfaces/masters/sequenceTemplate';

@Injectable()
export class SeqTemplateService extends SeqTemplateData {

  constructor(private api: SeqTemplateApi) {
    super();
  }

//   fireRequest(data: Department, method: string) {
//     const links = data.links
//         ? data.links.find(x => x.method === method)
//         : null;
//     switch (method) {
//         case 'DELETE': {
//             return this.api.delete(links.href);
//         }
//         case 'POST': {
//             return this.api.add(links.href,data);
//         }
//         case 'PUT': {
//             return this.api.update(links.href, data);
//         }
//         default: {
//             console.log(`${links.method} not found!!!`);
//             break;
//         }
//     }
// }

  list(url: string): Observable<SeqTemplate[]> {
    return this.api.list(url);
  }

  getById(url:string): Observable<SeqTemplate>{
      return this.api.getById(url);
  }

  create(url: string, data:SeqTemplate): Observable<SeqTemplate> {
    return this.api.add(url,data);
  }

  update(url: string, data:SeqTemplate): Observable<SeqTemplate> {
    return this.api.update(url,data);
  }

  

  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }

  // For Barcode Template page:-
  listbarcode(url: string): Observable<any[]> {
    return this.api.list(url);
  }

  createbarcode(url: string, data:any): Observable<any> {
    return this.api.add(url,data);
  }

}
